import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@cmps/ng-bootstrap';

import { FocusIdentifier } from '../../coaching-tags/tags/tags.model';
import { TranslationKeyMap } from '../coaching-observation.i18n';

export enum ObservationCommitOption {
    PUBLISH,
    CANCEL,
}

export enum ObservationCommitDialogItemStatus {
    UPDATED,
    NONE,
    NEW,
}

export interface ObservationCommitDialogResult {
    option: ObservationCommitOption;
    behaviourId: number;
    subBehaviourId: number;
    items?: ObservationCommitDialogItem[];
}

export interface ObservationCommitDialogItem {
    ID: FocusIdentifier;
    BehaviourId: number;
    SubBehaviourId: number;
    BehaviourText: string;
    SubBehaviourText: string;
    Status: ObservationCommitDialogItemStatus;

    /* TODO revise */
    trackingId: number;
    commitmentId: number;
    touched: boolean;
}

@Component({
    selector: '[cmpsObservationCommitDialog]',
    templateUrl: './observation-commit-dialog.component.html',
})
export class ObservationCommitDialogComponent {
    /** @private */ _i18n = TranslationKeyMap;
    @Input() Items: ObservationCommitDialogItem[];

    selectedID: string; // TODO revise. unused?
    selectedBehaviour: number;
    selectedSubBehaviour: number;
    _dialogResult = ObservationCommitOption;

    constructor(public _activeModal: NgbActiveModal) {
        this.Items = [];
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    existingFocusList = () => {
        return this.Items.filter(
            (x) => x.Status !== ObservationCommitDialogItemStatus.NEW,
        ).sort((a, b) => a.Status - b.Status);
    };

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    newFocusList = () => {
        return this.Items.filter(
            (x) => x.Status === ObservationCommitDialogItemStatus.NEW,
        );
    };

    /** @private */
    _onSelectedFocusChange(item: ObservationCommitDialogItem): void {
        this.selectedID = item.ID;
        this.selectedBehaviour = item.BehaviourId;
        this.selectedSubBehaviour = item.SubBehaviourId;
    }

    /** @private */
    _publish(): void {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const result = {
            option: this._dialogResult.PUBLISH,
            behaviourId: this.selectedBehaviour,
            subBehaviourId: this.selectedSubBehaviour,
            items: this.Items,
        } as ObservationCommitDialogResult;
        this._activeModal.close(result);
    }

    /** @private */
    _isDisabled(item: ObservationCommitDialogItem): boolean {
        return item.Status === ObservationCommitDialogItemStatus.NONE;
    }

    /** @private */
    _isChecked(item: ObservationCommitDialogItem): boolean {
        return (
            item.BehaviourId === this.selectedBehaviour &&
            item.SubBehaviourId === this.selectedSubBehaviour
        );
    }
}
